<template>
  <span class="def-price-old">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'DefPriceOld',
};
</script>

<style lang="scss" scoped>
.def-price-old {
  text-decoration-line: line-through;
  color: var(--color-dark-grey);
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
}
</style>
